import {Grid, Icon, Stack, Typography} from "@mui/material";
import React from "react";
import {PASSWORD_ERROR} from "@/components/admin/login/types";
import {useTranslation} from "react-i18next";

const PasswordCheck = ({passwordError, isPasswordMatch}: {passwordError: PASSWORD_ERROR; isPasswordMatch: () => boolean}) => {
    const {t} = useTranslation("login");
    return <Grid container sx={{mt: 2}}>
        <Stack direction="column" spacing={1}>
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <Icon
                    color={!passwordError?.length ? "success" : "error"}
                    sx={{fontSize: "1.2rem!important"}}
                >
                    {!passwordError.length ? "check_circle" : "info_icon"}
                </Icon>
                <Typography variant="body2">{t('passwords.type_1')}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <Icon
                    color={!passwordError?.upperCase ? "success" : "error"}
                    sx={{fontSize: "1.2rem!important"}}
                >
                    {!passwordError.upperCase ? "check_circle" : "info_icon"}
                </Icon>
                <Typography variant="body2">{t('passwords.type_2')}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <Icon
                    color={!passwordError?.number ? "success" : "error"}
                    sx={{fontSize: "1.2rem!important"}}
                >
                    {!passwordError.number ? "check_circle" : "info_icon"}
                </Icon>
                <Typography variant="body2">{t('passwords.type_3')}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <Icon
                    color={!passwordError?.special ? "success" : "error"}
                    sx={{fontSize: "1.2rem!important"}}
                >
                    {!passwordError.special ? "check_circle" : "info_icon"}
                </Icon>
                <Typography variant="body2">{t('passwords.type_4')}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.5}>
                <Icon
                    color={isPasswordMatch() ? "success" : "error"}
                    sx={{fontSize: "1.2rem!important"}}
                >
                    {isPasswordMatch() ? "check_circle" : "info_icon"}
                </Icon>
                <Typography variant="body2">{t('passwords.type_5')}</Typography>
            </Stack>
        </Stack>
    </Grid>
}

export default PasswordCheck;